import { createDerivedWritableAtom } from '../../../utils';
import { visitorAtom } from '../../state';

export const deadlineAtom = createDerivedWritableAtom(visitorAtom, 'deadline');
export const sessionConversationSidAtom = createDerivedWritableAtom(visitorAtom, 'sessionConversationSid');
